import React, {useContext} from "react";
import "./Footer.scss";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={500} distance="5px">
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          Portfolio © Aymen Maqsood
        </p>
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          made by{" "}
          <a
            href="https://github.com/mulbagalamaq"
            target="_blank"
            rel="noreferrer"
          >
            Aymen
          </a>
        </p>
      </div>
    </Fade>
  );
}
